<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card :title="$t('ShiftsList') |ToUppercase">
                <vs-button class="float-left" color="success" type="filled" to="/shift/add">{{$t('ShiftAdd')}}</vs-button>

                <vs-table :noDataText="$t('NoShiftsFound')" max-items="14" pagination search :data="shifts">
                    <template slot="thead">
                        <vs-th sort-key="id">#</vs-th>
                        <vs-th sort-key="id">{{ $t("Name") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("TimeFrom") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("TimeTo") }}</vs-th>
                        <vs-th sort-key="id">{{ $t("Actions") }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                                <vs-td>{{ data[index].id}}</vs-td>
                                <vs-td>{{ data[index].name}}</vs-td>
                                <vs-td>{{ data[index].timeFrom}}</vs-td>
                                <vs-td>{{ data[index].timeTo}}</vs-td>
                                <vs-td class="grid justify-items-start">
                                    <!--<vs-button color="primary" class="" @click="$router.push('/shift/' + data[index].id)" type="border" icon="build" >{{$t('View') | ToUppercase}}</vs-button>-->
                                    <vs-button color="primary" class="float-left mr-2" @click="$router.push('/shift/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                    <vs-button color="primary" class="float-left" @click="deleteShift(data[index].id)" type="border" icon="delete" >{{$t('Delete') | ToUppercase}}</vs-button>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </vx-card>
        </div>
    </div>
</template>

<script>
    export default {
        data() {    
            return {
                selected: "",
                shifts: [],
            };
        },
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        computed: {

        },
        created() {
            this.getShifts();
        },
        methods: {
            getShifts() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/')
                .then(function (response) {
                    thisIns.shifts = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju izmen",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            deleteShift(id) {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.delete('/shift/' + id)
                .then(function (response) {
                    thisIns.getShifts();
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri brisanju izmene",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        }
    };
</script>
